import { useNavigate } from 'react-router-dom';
import useInView from '../../../hooks/useInView';

const FinalCTA = () => {
  const navigate = useNavigate();
  const { ref, inView } = useInView({ threshold: 0.15 });

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-[#C41E3A]">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-800 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      >
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-5">
          Ready for Total Home Comfort?
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-white/85 mb-7 sm:mb-10 max-w-2xl mx-auto">
          Book an appointment, get a free estimate, or speak with a home comfort advisor today. Fast, reliable service with financing available.
        </p>
        <div
          style={{ transitionDelay: '200ms' }}
          className={`flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-8 sm:mb-10 transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <button
            onClick={() => navigate('/book-appointment')}
            className="bg-white text-[#C41E3A] px-8 py-4 rounded-lg text-base font-bold hover:bg-[#F8F9FB] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Book Appointment
          </button>
          <a
            href="tel:+18506698335"
            className="border-2 border-white text-white px-8 py-4 rounded-lg text-base font-bold hover:bg-white hover:text-[#C41E3A] transition-all hover:scale-105 flex items-center space-x-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill" />
            <span>Call Now</span>
          </a>
          <button
            onClick={() => navigate('/book-appointment')}
            className="text-white/80 border border-white/30 px-8 py-4 rounded-lg text-base font-semibold hover:text-white hover:border-white transition-all whitespace-nowrap cursor-pointer"
          >
            Get Free Estimate
          </button>
        </div>
        <div
          style={{ transitionDelay: '350ms' }}
          className={`flex items-center justify-center flex-wrap gap-4 sm:gap-6 text-white/70 text-xs sm:text-sm transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
        >
          <span className="flex items-center space-x-2">
            <i className="ri-check-line text-white" />
            <span>No Obligation</span>
          </span>
          <span className="flex items-center space-x-2">
            <i className="ri-check-line text-white" />
            <span>Same Day Available</span>
          </span>
          <span className="flex items-center space-x-2">
            <i className="ri-check-line text-white" />
            <span>Financing Available</span>
          </span>
          <span className="flex items-center space-x-2">
            <i className="ri-check-line text-white" />
            <span>100% Satisfaction Guaranteed</span>
          </span>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
